import { getAPIUrl } from '../../../../api/apiUtils';
import AxiosClient, { getLogOptions } from './axios.service';

export const createStudyEventDefinition = ({ accountId, authenticityToken, data, protocolId }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.post({
    data: {
      ...data,
      authenticity_token: authenticityToken,
    },
    options: getLogOptions(authenticityToken, createStudyEventDefinition.name),
    url: `${baseUrl}/administration/study_protocols/${protocolId}/study_event_definitions`,
  });
};

export const updateStudyEventDefinition = ({ accountId, authenticityToken, data, id, protocolId }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.put({
    data: {
      ...data,
      authenticity_token: authenticityToken,
    },
    options: getLogOptions(authenticityToken, updateStudyEventDefinition.name),
    url: `${baseUrl}/administration/study_protocols/${protocolId}/study_event_definitions/${id}`,
  });
};

export const deleteStudyEventDefinition = ({ accountId, authenticityToken, id, protocolId }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.delete({
    data: {
      authenticityToken,
    },
    options: getLogOptions(authenticityToken, deleteStudyEventDefinition.name),
    url: `${baseUrl}/administration/study_protocols/${protocolId}/study_event_definitions/${id}`,
  });
};
